import i18next from 'i18next';
import { useState } from 'react';

import Box from '@mui/material/Box';
import { MenuList } from '@mui/material';
import Popover from '@mui/material/Popover';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';

import { useDoctor } from 'src/hooks/use-doctor';

// ----------------------------------------------------------------------

const LANGS = [
  {
    value: 'en',
    label: 'English (US)',
    icon: '/assets/icons/ic_flag_en.svg',
  },
  {
    value: 'en-GB',
    label: 'English (GB)',
    icon: '/assets/icons/ic_flag_gb.svg',
  },
  {
    value: 'hr',
    label: 'Croatian',
    icon: '/assets/icons/ic_flag_hr.svg',
  },
  {
    value: 'pt-PT',
    label: 'Portuguese',
    icon: '/assets/icons/ic_flag_pt.svg',
  },
  // {
  //   value: 'es',
  //   label: 'Spanish',
  //   icon: '/assets/icons/ic_flag_es.svg',
  // },
];

// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const [open, setOpen] = useState<HTMLButtonElement | null>(null);

  const { lang, setLang } = useDoctor();

  // The highlighted flag follows the shared language; if that isn't one of the
  // listed options, fall back to whatever i18next resolved (e.g. from the cookie).
  const sharedIndex = LANGS.findIndex((option) => option.value === lang);
  const langId =
    sharedIndex === -1 ? LANGS.findIndex((option) => option.value === i18next.language?.toLowerCase()) : sharedIndex;

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleClick = (index: number) => {
    setLang(LANGS[index].value);
    setOpen(null);
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
          ...(open && {
            bgcolor: 'action.selected',
          }),
        }}
      >
        <img src={LANGS?.[langId]?.icon} alt={LANGS?.[langId]?.label} />
      </IconButton>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              p: 0,
              mt: 1,
              ml: 0.75,
              width: 180,
            },
          },
        }}
      >
        <MenuList>
          {LANGS.map((option, index) => (
            <MenuItem
              key={option.value}
              selected={option.value === LANGS[langId]?.value}
              onClick={() => handleClick(index)}
              sx={{ typography: 'body2', py: 1 }}
            >
              <Box component="img" alt={option.label} src={option.icon} sx={{ width: 28, mr: 2 }} />

              {option.label}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </>
  );
}
